import { GetApprovalResponseSchema } from '../get-approval/get-approval.schema';
/**
 * Withdraw Approval
 * POST /api/v2/approval/:id/withdraw — the requester takes a pending request back.
 */ export const WithdrawApprovalResponseSchema = GetApprovalResponseSchema;

//# sourceMappingURL=withdraw-approval.schema.js.map